import { HiveLink } from './link-node/hive-link';
import { LinkPopup } from './link-node/link-popup/link-popup';

export function effects() {
  customElements.define('link-popup', LinkPopup);
  customElements.define('hive-link', HiveLink);
}
